export enum httpResponse {
	UNAUTHORIZED = 'Unauthorized',
	OK = 'OK',
	KO = 'KO',
}

export enum httpStatus {
	OK = 200,
	BAD_REQUEST = 400,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	INTERNAL = 500
}